/* eslint-disable linebreak-style */
/* eslint-disable react/jsx-filename-extension */
/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable import/extensions */
import React, { Component } from 'react';

import Header from 'parts/Header';
import Footer from 'parts/Footer';

import { Fade } from 'react-awesome-reveal';
import Team from 'assets/images/hero/team.png';

export default class AboutPage extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <>
        <Header />
        <section className="hero sm:items-center lg:items-start sm:flex-row mb-12 lg:mb-20">
          <div className="w-full sm:w-1/2 flex flex-col px-5 mb-5 sm:mb-0 sm:px-12 sm:mt-6 lg:mt-6 xl:mt-20">
            <Fade direction="up" triggerOnce>
              <h1 className="text-6xl text-theme-blue font-bold leading-tight mb-5">
                About Us
              </h1>
            </Fade>
            <Fade direction="up" delay={500} triggerOnce>
              <p className="font-light text-xl text-gray-400 leading-relaxed">
                We are Drava Studio, a passionate team of innovators creating beautiful and robust digital experiences.
              </p>
            </Fade>
          </div>
          <div className="flex pt-5 w-full justify-center items-center order-first md:w-full lg:order-last lg:w-1/2">
            <Fade direction="top-right" triggerOnce delay={300}>
                <img src={Team} alt="About Us" className="rounded-2xl" />
            </Fade>
          </div>
        </section>

        <section className="container mx-auto px-4 md:px-12 py-16 lg:pb-32">
          <div className="max-w-4xl mx-auto space-y-12">
            
            <Fade direction="up" triggerOnce delay={600}>
                <div>
                <h2 className="text-3xl font-bold text-theme-blue mb-6">Our Mission</h2>
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                    At Drava Studio, our core mission is to merge advanced AI technologies with intuitive design to create software that doesn't just meet requirements, but transforms how businesses and individuals interact with technology. We believe in providing solutions that are scalable, efficient, and deeply aligned with our partners' visions.
                </p>
                </div>
            </Fade>

            <Fade direction="up" triggerOnce delay={700}>
                <div>
                <h2 className="text-3xl font-bold text-theme-blue mb-6">Who We Are</h2>
                <p className="text-lg text-gray-500 font-light leading-relaxed">
                    We are a collective of developers, designers, and strategists. Formed with a common goal to innovate in the AI and mobile development spaces. From cutting-edge cloud infrastructures to engaging user interfaces, our expertise spans across the entire digital spectrum.
                </p>
                </div>
            </Fade>

            <Fade direction="up" triggerOnce delay={800}>
                <div>
                <h2 className="text-3xl font-bold text-theme-blue mb-6">What We Do</h2>
                <ul className="text-lg text-gray-500 font-light leading-relaxed space-y-3 list-disc pl-5">
                    <li>Custom AI and Machine Learning Integrations</li>
                    <li>Sleek and performant Mobile Applications</li>
                    <li>Robust and secure Cloud Backends</li>
                    <li>Full-scale Web Solutions and System maintenance</li>
                </ul>
                </div>
            </Fade>
            
          </div>
        </section>
        <Footer />
      </>
    );
  }
}
